'use client';
import { jsx } from 'react/jsx-runtime';
import { PopoverTrigger } from './popover-trigger.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PopoverLauncher = renderWithRef('PopoverLauncher', null, (e, p)=>{
    let { children: t } = e;
    return jsx(RenderComp, {
        root: "span",
        forwardedRef: p,
        classNames: [
            'swan-popover-launcher'
        ],
        props: e,
        children: jsx(PopoverTrigger, {
            children: t
        })
    });
});

export { PopoverLauncher };
